




























import { computed, defineComponent, ref } from '@vue/composition-api';
import { BaseButtonIcon } from '../base-button-icon';
import { BaseIcon } from '../base-icon';

export default defineComponent({
  name: 'BaseTreeStructure',
  components: {
    BaseButtonIcon,
    BaseIcon,
    BaseTreeStructure: () => import('./_base-tree-structure.vue'),
  },
  props: {
    root: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    children: {
      type: Array,
      default: () => [],
    },
    childrenKey: {
      type: String,
      required: true,
    },
    rootExpanded: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const showExpand = computed(() => !!props.children?.length);
    const expanded = ref(props.rootExpanded);

    const toggleExpand = () => {
      expanded.value = !expanded.value;
      emit(expanded.value ? 'expand' : 'collapse', props.item);
    };

    return {
      showExpand,
      expanded,
      toggleExpand,
    };
  },
});
